import { Chance } from 'chance';
import { PapiAdoptableOffer } from '@wix/da-papi-types';
import { users } from '../users';

const chance = new Chance();

export function makeAdoptableOffer(
  overrides: Partial<PapiAdoptableOffer> = {}
): PapiAdoptableOffer {
  return {
    offerId: chance.integer({ min: 1 }),
    from: chance.pickone(users),
    to: chance.pickone(users),
    ts: `${Date.now() - 3600 * chance.integer({ min: 1, max: 24 }) * 1000}`, // somewhere within the last 24hs
    dollarPrice: chance.integer({ min: 10, max: 80 }),
    isAnonymous: 0,
    status: 'created',
    ...overrides,
  };
}
